import React, { useState, useEffect } from 'react';
import * as State from '../state';
import { useTranslate } from 'react-translate';

import './download-files-activity.css';

const inDuration = 500;
let initialState = true

export function DownloadFilesActivity(props) {
    const common = useTranslate('Common');
    const [state, setState] = useState(State.init);
    const [vote, setVote] = useState('');
    let [items, setItems] = useState([])
    const { callHubAsync, theme } = props;

    useEffect(() => {
        let cancelled = false;
        let onError = (error) => {
            initialState = true
            if (!cancelled) {
                console.error(error);
                setState(State.error);
            }
        }
        if (state === State.init) {
            initialState = true
            new Promise(r => setTimeout(r, inDuration))
                .then(() => {
                    if (!cancelled) {
                        setState(State.ready);
                    }
                })
                .catch(onError);

            return () => cancelled = true;
        }
        if (state === State.ready) {
            
            async function displayImages(choicesArray) {
                items = await displayFilesThumb(choicesArray, false)
                setItems(items)
            }

            function createElementsArray(files) {
                let elementsArray = [];
                if (files !== undefined) {
                    for (let i = 0; i < files.length; i++) {
                        elementsArray.push({
                            'name': files[i].name,
                            'fileUri': files[i].fileUri,
                            'thumbnailUri': files[i].thumbnailUri,
                            'link': files[i].link
                        });
                    }
                }
                //console.log(elementsArray)
                return elementsArray
            }

            if (initialState) {
                items = createElementsArray(props.filesArgs)
                displayImages(items);
                initialState = false
            }
        }
    }, [state, callHubAsync, setVote, setState, setItems])

    async function displayFilesThumb(filesArray, fromEvent) {
        
        let itemList = []
        
        for (let i = 0; i < filesArray.length; i++) {
            //requete pour get le fichier ?
            let file = await getFileAsync(filesArray[i].thumbnailUri);
            //console.log(file)
            //console.log(file.type)
           if (file != null) {
               var binaryData = [];
               if (filesArray[i].name !== undefined)
               {
                   binaryData.push(file);
                   let urlImage = window.URL.createObjectURL(new Blob(binaryData, { type: file.type }));
                   let resourceUri = undefined;
                   let pathData = undefined;
                   if (filesArray[i].link !== undefined) {
                       resourceUri = filesArray[i].link;
                       pathData = "M 697.00,299.00 C 697.00,299.00 619.00,299.00 619.00,299.00 619.00,299.00 532.00,299.00 532.00,299.00 524.09,298.99 517.50,297.28 513.01,289.99 507.58,281.17 510.68,266.40 521.00,262.60 522.94,261.88 525.91,262.00 528.00,262.00 528.00,262.00 708.00,262.00 708.00,262.00 708.00,262.00 747.00,262.00 747.00,262.00 757.62,262.07 761.98,267.86 762.00,278.00 762.00,278.00 762.00,496.00 762.00,496.00 762.00,498.09 762.12,501.06 761.40,503.00 757.60,513.32 742.83,516.42 734.01,510.99 726.72,506.50 725.01,499.91 725.00,492.00 725.00,492.00 725.00,327.00 725.00,327.00 725.00,327.00 706.03,346.03 706.03,346.03 706.03,346.03 666.03,386.03 666.03,386.03 666.03,386.03 547.00,505.00 547.00,505.00 547.00,505.00 521.00,531.00 521.00,531.00 516.82,535.18 509.62,542.88 505.00,545.89 496.70,551.30 484.97,549.89 478.79,541.91 472.97,534.40 473.92,524.29 479.53,517.00 479.53,517.00 521.00,475.00 521.00,475.00 521.00,475.00 697.00,299.00 697.00,299.00 Z M 343.00,296.14 C 343.00,296.14 382.00,296.14 382.00,296.14 382.00,296.14 454.00,296.14 454.00,296.14 460.21,296.01 465.82,296.44 470.91,300.56 480.52,308.33 479.83,324.10 469.96,331.35 465.16,334.88 460.65,334.99 455.00,335.00 455.00,335.00 353.00,335.00 353.00,335.00 333.86,335.03 314.68,345.74 305.63,363.00 300.84,372.14 299.02,384.76 299.00,395.00 299.00,395.00 299.00,663.00 299.00,663.00 299.02,673.85 300.58,687.29 305.67,697.00 307.18,699.88 310.13,703.53 312.29,706.00 325.36,720.97 340.80,724.97 360.00,725.00 360.00,725.00 534.00,725.00 534.00,725.00 534.00,725.00 630.00,725.00 630.00,725.00 639.38,724.89 651.55,723.04 660.00,718.87 676.50,710.72 688.78,691.37 689.00,673.00 689.00,673.00 689.00,567.00 689.00,567.00 689.15,555.17 697.30,544.98 710.00,546.20 723.68,547.51 727.98,557.86 728.00,570.00 728.00,570.00 728.00,650.00 728.00,650.00 728.00,669.10 728.98,688.82 721.93,707.00 720.39,710.98 718.71,713.37 716.65,717.00 706.45,734.98 693.84,746.91 675.00,755.54 666.07,759.63 661.98,761.98 652.00,762.00 652.00,762.00 336.00,762.00 336.00,762.00 326.06,761.98 321.92,759.24 313.00,755.42 292.96,746.84 276.72,729.94 268.15,710.00 264.41,701.29 262.02,697.69 262.00,688.00 262.00,688.00 262.00,372.00 262.00,372.00 262.02,361.71 264.71,357.18 268.92,348.00 277.25,329.85 289.74,317.15 307.00,307.35 310.63,305.29 313.02,303.61 317.00,302.07 325.36,298.82 334.21,297.75 343.00,296.14 Z";
                   }
                   else if (filesArray[i].fileUri !== undefined) {
                       resourceUri = filesArray[i].fileUri;
                       pathData = "M 494.00,657.00 C 494.00,657.00 494.00,334.00 494.00,334.00 494.00,334.00 494.00,258.00 494.00,258.00 494.01,249.66 495.64,240.32 505.00,237.51 507.14,236.87 511.64,236.96 514.00,237.00 526.96,237.22 529.98,246.97 530.00,258.00 530.00,258.00 530.00,532.00 530.00,532.00 530.00,532.00 530.00,616.00 530.00,616.00 530.00,624.63 529.10,650.32 531.00,657.00 533.40,652.28 537.89,648.90 541.60,645.20 541.60,645.20 562.20,624.60 562.20,624.60 562.20,624.60 631.17,555.72 631.17,555.72 631.17,555.72 649.00,538.00 649.00,538.00 654.56,532.45 659.42,527.38 668.00,528.20 678.00,529.15 685.75,537.89 684.89,548.00 684.10,557.36 672.41,566.59 666.00,573.00 666.00,573.00 613.96,625.09 613.96,625.09 613.96,625.09 543.04,695.99 543.04,695.99 538.07,701.03 524.44,715.79 519.00,717.99 516.38,719.05 512.81,719.11 510.00,718.96 502.42,718.54 499.11,714.02 494.01,709.04 494.01,709.04 471.00,686.00 471.00,686.00 471.00,686.00 373.00,588.00 373.00,588.00 373.00,588.00 348.58,563.72 348.58,563.72 343.24,558.27 338.42,553.19 339.11,545.00 339.94,535.12 349.07,527.25 359.00,528.20 367.26,528.99 371.52,534.52 377.00,540.00 377.00,540.00 404.00,566.99 404.00,566.99 404.00,566.99 439.65,602.42 439.65,602.42 439.65,602.42 476.00,638.80 476.00,638.80 476.00,638.80 494.00,657.00 494.00,657.00 Z M 334.00,752.70 C 339.94,751.36 357.83,752.00 365.00,752.08 365.00,752.08 426.00,752.08 426.00,752.08 426.00,752.08 619.00,752.08 619.00,752.08 619.00,752.08 682.00,752.08 682.00,752.08 684.08,752.00 687.02,751.92 689.00,752.08 697.39,754.50 702.43,762.69 701.91,771.00 701.50,777.47 697.41,784.35 691.00,786.44 688.96,787.11 686.16,787.00 684.00,787.00 684.00,787.00 340.00,787.00 340.00,787.00 337.32,786.99 334.52,787.16 332.00,786.07 320.53,781.06 316.16,760.74 334.00,752.70 Z";
                   }

                   if (resourceUri !== undefined) {
                       itemList.push(
                           <a key={i + "_checkButton"} className="dlFilesContainer" href={resourceUri} target="_blank">
                               <img className="image" id={i + "_image"} alt="PossibleChoice" src={urlImage}></img>
                               <svg className="downloadBtn" id={i + "_dlButton"} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                                   <circle cx="512" cy="512" r="512" fill={theme.lightAccentColor} />
                                   <path d={pathData}
                                         fill="white" />
                               </svg>
                           </a>)
                   }                   
               }
           }
            
        }
        if (itemList.length === 0) {
            itemList.push(
                <div key="noChoices">En attente de fichiers</ div>)
        }
        
        setItems(itemList)
        
        return itemList;
    }

    async function getFileAsync(fileUri) {
        return await fetch(fileUri, { method: 'GET' })
            .then((response) => response.blob())
            .then(data => { return data; });
    }    

    return (
        <form>
            <div className="wrapper">
                {items}
            </div>

            <p style={{ opacity: state === State.error ? 1 : 0 }}> {/* just hidden to keep layout */}
                {common('error.retry')}
            </p>
        </form>
    );
}

    